/*       */

import { gql } from '@apollo/client';
import loadWorkspaceDetailsCommonQuery from 'graphql/workspaces/loadWorkspaceDetailsCommonQuery';

export default gql`
    mutation removeWorkspaceClassesMutation($id: ID!, $classes: [ID]!) {
        result: workspaceRemoveClasses(id: $id, classes: $classes) {
            ${loadWorkspaceDetailsCommonQuery}
        }
    }
`;
